import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import Auth from '.';
import { useSelector } from 'react-redux';
import { MainLayoutProps } from '../../Api/Interface/layout.interface';
import { useGetUserQuery } from '../../Api/attoDeskApi';
import { selectEnableAuth } from '../../Store/Auth/AuthSelector';
import { Loader } from '../../Components/Loader';

const PUBLIC_AUTH_PATHS = ['/reset-password', '/forgot-password'];

const LoginProvider = ({ children }: MainLayoutProps) => {
  const { isLoading } = useGetUserQuery();
  const authEnable = useSelector(selectEnableAuth);
  const location = useLocation();

  const isPublicAuthPath = PUBLIC_AUTH_PATHS.some((p) => location.pathname.startsWith(p));

  const renderComponent = useMemo(() => {
    if (isLoading) {
      return <Loader />;
    }
    if (isPublicAuthPath) {
      return <Auth />;
    }
    return authEnable ? children : <Auth />;
  }, [isLoading, authEnable, children, isPublicAuthPath]);
  return <>{renderComponent}</>;
};

export default React.memo(LoginProvider);
